import { render, staticRenderFns } from "./Contacts.vue?vue&type=template&id=2b834f86&scoped=true"
import script from "./Contacts.vue?vue&type=script&lang=js"
export * from "./Contacts.vue?vue&type=script&lang=js"
import style0 from "./Contacts.vue?vue&type=style&index=0&id=2b834f86&prod&lang=scss"
import style1 from "./Contacts.vue?vue&type=style&index=1&id=2b834f86&prod&lang=scss&scoped=true"
import style2 from "./Contacts.vue?vue&type=style&index=2&id=2b834f86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b834f86",
  null
  
)

export default component.exports